/**
 * カウンター要素
 */
export default class CounterBox extends HTMLElement {
  constructor() {
    super();

    this.quantity = this.dataset.quantity;
    this.isBuildPrice = this.dataset.buildPrice;
    this.singlePurchaseAvailable = this.dataset.singlePurchaseAvailable;
    this.orderSizeChangerFlg = this.dataset.orderSizeChangerFlg;
    this.setProduct = this.dataset.setProduct;
    this.index = this.dataset.index;
    this.step = parseInt(this.dataset.step, 10);
    this.value = 0;
    this.favorited = false;

    
  }

  connectedCallback() {
    // カウンター要素の取得

    this.counter = this.querySelector('.counter .value');
    this.value = parseInt(this.counter.innerHTML, 10);    
    // 単位の表示
    const unitElem = this.querySelector('.unit');
    if(unitElem) {
      const unit = unitElem.getAttribute('unit');
      if (unit) {
        unitElem.innerHTML = unit;
      } else {
        unitElem.style.display = 'none';
      }
    }

    // ボタンアクション登録
    const buttonDown = this.querySelector('.button-down');
    const buttonUp = this.querySelector('.button-up');
    if(buttonDown && buttonUp) {

      if (this.singlePurchaseAvailable == 'true' || this.setProduct == 'true') {
        this.setButtonAction(buttonDown, buttonUp);
      } else if(this.orderSizeChangerFlg == 'true') {
        buttonDown.addEventListener("click", () => {
          this.decrement();
          console.log('decrement');
          
        });
    
        buttonUp.addEventListener("click", () => {
          this.increment();
          console.log('increment');
        });
      } else {
        buttonDown.disabled = true;
        buttonUp.disabled = true;
      }
    }
  }

  /**
   * ボタンアクション
   */
  setButtonAction(buttonDown, buttonUp) {
    buttonDown.addEventListener('click', (event) => {
      return new Promise((resolve) => {
        this.decrement();
        resolve();
      }).then(() => {
        this.changeEvent();
      });
    });

    buttonUp.addEventListener('click', (event) => {
      return new Promise((resolve) => {
        this.increment();
        resolve();
      }).then(() => {
        this.changeEvent();
      });
    });
  }

  /**
   * カウントアップ
   */
  increment() {
    const value = parseInt(this.counter.innerHTML, 10) + this.step;
    if(this.dataset.max) {
      const max = parseInt(this.dataset.max, 10);
      if (value > max) {
        alert('最大値を超えています');
        return;
      }
    }
    if (value < 9999) {
      this.counter.innerHTML = value;
      this.value = parseInt(value, 10);
    }
  }

  /**
   * カウントダウン
   */
  decrement() {
    const value = parseInt(this.counter.innerHTML, 10) - this.step;
    if(this.dataset.min) {
      const min = parseInt(this.dataset.min, 10);
      if (value < min) {
        alert('最小値を下回っています');
        return;
      }
    }
    if (value > 0) {
      this.counter.innerHTML = value;
      this.value = parseInt(value, 10);
    }
  }

  /**
   * 数量更新イベント
   */
  changeEvent() {
    const submitButton = document.querySelector('.unico-submit-button')
    const updateModal = document.querySelector('[data-target-id="cart-update-alert"] dialog');
    if(submitButton) {
      submitButton.disabled = true;
      this.classList.add('loading');
      if(updateModal) {
        updateModal.showModal();
      }
    }
    if (this.closest('[data-set-key]').dataset.setKey != 'false' && this.dataset.buildPrice == 'false') {
      // セット品の場合
      const setKey = this.closest('[data-set-key]').dataset.setKey;
      WLCart.updateSetQuantity(this.value, this);

    } else if (this.closest('[data-build-price-target]').dataset.buildPriceTarget != 'false') {
      // 組立料金対象商品の場合

      // 最大購入数のチェック
      this.maxPurchaseQuantity = this.dataset.maxPurchaseQuantity == "" ? null : this.dataset.maxPurchaseQuantity;
      
      if(this.maxPurchaseQuantity != "" && this.maxPurchaseQuantity != null) {
        this.maxPurchaseQuantity = parseInt(this.maxPurchaseQuantity, 10);
        if(this.value > this.maxPurchaseQuantity) {
          this.value = this.maxPurchaseQuantity;
          this.counter.innerHTML = this.value;
          document.querySelector('[data-modal-target="wl-cart-error-control"]').click();
        }
      }

      // カート数量の変更
      WLCart.updateBuildPriceTargetQuantity(this.value, this);
      
    } else {
      // 通常商品の場合

      // 最大購入数のチェック
      this.maxPurchaseQuantity = this.dataset.maxPurchaseQuantity == "" ? null : this.dataset.maxPurchaseQuantity;
      
      if(this.maxPurchaseQuantity != "" && this.maxPurchaseQuantity != null) {
        this.maxPurchaseQuantity = parseInt(this.maxPurchaseQuantity, 10);
        if(this.value > this.maxPurchaseQuantity) {
          this.value = this.maxPurchaseQuantity;
          this.counter.innerHTML = this.value;
          document.querySelector('[data-modal-target="wl-cart-error-control"]').click();
        }
      }

      // カート数量の変更
      WLCart.updateQuantity(this.value, this);
    }
  }
}
